module.exports = __webpack_public_path__ + "img/ic-plus-in-circle.065e5f9a.svg";